
/*
 * MA VILLE EN DIAMANT
 * ROUE DE LA CHANCE — V19 FR + US
 *
 * Marchés :
 * FR, BE, CH, LU : français
 * US : anglais
 *
 * Une participation par navigateur
 * Fermeture mémorisée 30 jours
 * Gain valable 7 jours
 * Croix du bouton : masquage 30 jours
 *
 * Probabilités :
 * Boîte        55,8 %
 * Plateau      30 %
 * Dommage      0,1 %
 * Dommage      0,1 %
 * 10 %         12 %
 * Stylo         2 %
 */

(function () {
  "use strict";

  if (window.__mvdWheelV19Loaded) return;
  window.__mvdWheelV19Loaded = true;

  const CONFIG = {
    selector: "#mvd-wheel-v12",

    klaviyoSite: "UEqx8X",
    klaviyoList: "SRjAbi",

    countries: ["FR", "BE", "CH", "LU"],
    language: "fr",
    usCountry: "US",

    usCollection:
      "/en/collections/diamond-painting",

    collection:
      "/collections/peinture-diamant-ville",

    openDelay: 13000,
    spinDuration: 5000,
    idleSpeed: 360 / 35000,

    rewardKey: "mvd-wheel-final-reward-v1",
    testRewardKey:
      "mvd-wheel-editor-test-reward-v1",

    playedKey: "mvd-wheel-final-played-v1",
    closedKey: "mvd-wheel-final-closed-v1",

    rewardDays: 7,
    closedDays: 30,

    dismissedDays: 30,
    dismissedKey:
      "mvd-wheel-tab-dismissed-v1",

    giftProperty: "_mvd_wheel_gift",
    giftValue: "yes"
  };

  // RÉCOMPENSES ET PROBABILITÉS

  const PRIZES = [
    {
      name: "10 % de réduction",
      type: "percent",
      code: "BIENVENUE10",
      weight: 12,
      angle: 30
    },
    {
      name: "Plateau de tri offert",
      type: "gift",
      code: "PLATBIENV",
      weight: 30,
      angle: 90,
      handle:
        "boite-a-diamants-ma-ville-en-diamant"
    },
    {
      name: "Dommage !",
      type: "lose",
      code: "MVD-LOSE-1",
      weight: 0.1,
      angle: 150
    },
    {
      name: "Boîte de rangement 56 cases offerte",
      type: "gift",
      code: "ROUE-BOITE-56",
      weight: 55.8,
      angle: 210,
      handle:
        "boite-de-rangement-56-cellules-pour-diamants-organisation-et-praticite-pour-votre-diamond-painting"
    },
    {
      name: "Dommage !",
      type: "lose",
      code: "MVD-LOSE-2",
      weight: 0.1,
      angle: 270
    },
    {
      name: "Stylo multi-embouts offert",
      type: "gift",
      code: "ROUESTYLO",
      weight: 2,
      angle: 330,
      handle:
        "stylo-multifonction-a-embouts-metalliques-ma-ville-en-diamant-1"
    }
  ];

  // PRODUITS DU MARCHÉ AMÉRICAIN

  const US_GIFT_HANDLES = {
    PLATBIENV:
      "sorting-tray-ma-ville-en-diamant",

    "ROUE-BOITE-56":
      "56-cell-diamond-storage-box-organization-convenience",

    ROUESTYLO:
      "multifunction-diamond-painting-pen-with-metal-tips-ma-ville-en-diamant"
  };

  // DÉTECTION DU MARCHÉ

  function isUS() {
    return getAudience().country === "US";
  }

  function localized(textFr, textUs) {
    return isUS() ? textUs : textFr;
  }

  function rewardHandle(reward) {
    return isUS()
      ? (
          US_GIFT_HANDLES[reward.code] ||
          reward.handle
        )
      : reward.handle;
  }

  function collectionPath() {
    return isUS()
      ? CONFIG.usCollection
      : CONFIG.collection;
  }

  // VARIABLES GÉNÉRALES

  const DAY = 24 * 60 * 60 * 1000;

  let collectionPromise = null;
  let syncBusy = false;
  let syncAgain = false;
  let syncTimer = null;

  let lastStatus = "pending";
  let lastRewardId = null;
  let failedSignature = null;

  let variantCache = {};
  let drawerObserver = null;
  let currentRoot = null;

  const normalize = value =>
    ((value % 360) + 360) % 360;

  const sleep = ms =>
    new Promise(resolve =>
      setTimeout(resolve, ms)
    );

  // PAYS, LANGUE ET ANCIENS CLIENTS

  function getAudience() {
    const root = document.querySelector(
      CONFIG.selector
    );

    const shopify = window.Shopify || {};

    // Mode test uniquement dans l'éditeur Shopify

    const testMode = Boolean(
      shopify.designMode
    );

    const country = String(
      root?.dataset.mvdCountry ||
      shopify.country ||
      ""
    ).toUpperCase();

    const language = String(
      root?.dataset.mvdLanguage ||
      shopify.locale ||
      document.documentElement.lang ||
      ""
    ).toLowerCase();

    const orders = String(
      root?.dataset.mvdCustomerOrders ||
      "unknown"
    );

    const frenchMarket =
      CONFIG.countries.includes(country) &&
      (
        language === "fr" ||
        language.startsWith("fr-")
      );

    const americanMarket =
      country === "US" &&
      (
        language === "en" ||
        language.startsWith("en-")
      );

    return {
      country,
      language,
      orders,
      testMode,

      allowed:
        (
          testMode ||
          frenchMarket ||
          americanMarket
        ) &&
        !(
          orders !== "unknown" &&
          Number(orders) > 0
        )
    };
  }

  function isAllowedAudience() {
    return getAudience().allowed;
  }

  // STOCKAGE DANS LE NAVIGATEUR

  function readStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.warn(
        "[MVD] Stockage indisponible",
        error
      );
    }
  }

  function removeStorage(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {}
  }

  // MÉMORISER UNE PREMIÈRE VISITE

  function rememberVisit() {
    try {
      if (
        !localStorage.getItem(
          "mvd-wheel-first-visit-v1"
        )
      ) {
        localStorage.setItem(
          "mvd-wheel-first-visit-v1",
          String(Date.now())
        );
      }
    } catch (error) {}
  }

  // EMPÊCHER DE JOUER PLUSIEURS FOIS

  function hasPlayed() {
    if (getAudience().testMode) {
      return false;
    }

    return (
      readStorage(CONFIG.playedKey) === "yes" ||
      Boolean(getReward())
    );
  }

  function markPlayed() {
    if (getAudience().testMode) {
      return;
    }

    writeStorage(
      CONFIG.playedKey,
      "yes"
    );
  }

  // MASQUER LA PROPOSITION PENDANT 30 JOURS

  function isDismissed() {
    if (getAudience().testMode) {
      return false;
    }

    const date = Number(
      readStorage(CONFIG.dismissedKey)
    );

    return (
      Number.isFinite(date) &&
      date > 0 &&
      Date.now() - date <
        CONFIG.dismissedDays * DAY
    );
  }

  function dismissForMonth() {
    if (getAudience().testMode) {
      return;
    }

    writeStorage(
      CONFIG.dismissedKey,
      String(Date.now())
    );
  }

  // FERMETURE CLASSIQUE : 30 JOURS

  function isClosedRecently() {
    if (getAudience().testMode) {
      return false;
    }

    const raw = readStorage(
      CONFIG.closedKey
    );

    if (!raw) return false;

    const timestamp = Number(raw);

    if (!Number.isFinite(timestamp)) {
      return false;
    }

    return (
      Date.now() - timestamp <
      CONFIG.closedDays * DAY
    );
  }

  function markClosed() {
    if (getAudience().testMode) {
      return;
    }

    writeStorage(
      CONFIG.closedKey,
      String(Date.now())
    );
  }

  // GAIN VALABLE 7 JOURS

  function activeRewardKey() {
    return getAudience().testMode
      ? CONFIG.testRewardKey
      : CONFIG.rewardKey;
  }

  function getReward() {
    try {
      const raw = readStorage(
        activeRewardKey()
      );

      if (!raw) return null;

      const reward = JSON.parse(raw);

      if (
        !reward ||
        !reward.code ||
        !reward.rewardId ||
        !reward.createdAt
      ) {
        return null;
      }

      const expired =
        Date.now() - reward.createdAt >
        CONFIG.rewardDays * DAY;

      if (expired) {
        removeStorage(
          activeRewardKey()
        );

        return null;
      }

      return reward;

    } catch (error) {
      return null;
    }
  }

  // ENREGISTRER LE GAIN

  function saveReward(prize) {
    // Une case perdante est une participation définitive, sans cadeau.
    if (prize.type === "lose") {
      markPlayed();
      return null;
    }

    const reward = {
      name: prize.name,
      type: prize.type,
      code: prize.code,

      handle:
        rewardHandle(prize) || null,

      createdAt: Date.now(),

      rewardId:
        Date.now() + "-" +
        Math.random()
          .toString(36)
          .slice(2)
    };

    writeStorage(
      activeRewardKey(),
      JSON.stringify(reward)
    );

    markPlayed();

    lastRewardId = reward.rewardId;
    lastStatus = "pending";
    failedSignature = null;

    showNotice(reward, "pending");
    updateShippingVisibility();

    return reward;
  }

  // NOTIFICATION DU CADEAU APRÈS LA ROUE

  function showGiftReminder() {
    const reward = getReward();

    if (!reward || !isAllowedAudience()) {
      return;
    }

    const oldToast = document.getElementById(
      "mvd-wheel-gift-toast"
    );

    if (oldToast) {
      oldToast.remove();
    }

    const toast = document.createElement("div");

    toast.id = "mvd-wheel-gift-toast";
    toast.setAttribute("role", "status");

    toast.style.cssText = [
      "position:fixed",
      "top:90px",
      "right:15px",
      "z-index:2147483001",
      "max-width:310px",
      "padding:15px 18px",
      "border-radius:10px",
      "background:#edf5ef",
      "color:#315c45",
      "box-shadow:0 5px 20px #0002",
      "font-size:13px",
      "line-height:1.5"
    ].join(";");

    const title = document.createElement("strong");

    title.textContent = localized(
      "Votre cadeau est en attente !",
      "Your gift is waiting!"
    );

    const description = document.createElement("div");

    description.textContent = localized(
      "Ajoutez votre Diamond Painting préféré au panier pour en profiter.",
      "Add your favorite Diamond Painting to your cart to claim it."
    );

    toast.append(title, description);

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 5000);
  }

  // INSCRIPTION KLAVIYO

  async function subscribeKlaviyo(email) {
    const audience = getAudience();
    const countryCode = audience.country;
    const us = countryCode === "US";

    const locale = us ? "en-US" : "fr-FR";

    const countryNames = {
      US: "United States",
      FR: "France",
      BE: "Belgium",
      CH: "Switzerland",
      LU: "Luxembourg"
    };

    const country = countryNames[countryCode];

    const headers = {
      "Content-Type": "application/vnd.api+json",
      Accept: "application/vnd.api+json",
      revision: "2026-07-15"
    };

    const baseUrl =
      "https://a.klaviyo.com/client/";

    const companyId =
      "?company_id=" +
      encodeURIComponent(CONFIG.klaviyoSite);

    // 1. Inscription à la liste Klaviyo

    const response = await fetch(
      baseUrl + "subscriptions" + companyId,
      {
        method: "POST",
        headers,
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email,
                    locale,
                    properties: {
                      Source_inscription:
                        "Roue de la chance",
                      Langue_Roue: locale,
                      Marche_Roue: us ? "US" : "FR"
                    }
                  }
                }
              },
              custom_source: us
                ? "Ma Ville en Diamant - Lucky Wheel US"
                : "Ma Ville en Diamant - Roue de la chance FR"
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: CONFIG.klaviyoList
                }
              }
            }
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        "Inscription Klaviyo refusée : " +
        response.status
      );
    }

    // 2. Mise à jour du pays et de la langue

    const attributes = {
      locale,
      properties: {
        Langue_Roue: locale,
        Marche_Roue: us ? "US" : "FR"
      }
    };

    if (country) {
      attributes.location = {
        country
      };
    }

    try {
      const profileResponse = await fetch(
        baseUrl + "profiles" + companyId,
        {
          method: "POST",
          headers,
          
          body: JSON.stringify({
            data: {
              type: "profile",
              attributes,
              meta: {
                identifiers: {
                  email
                }
              }
            }
          })
        }
      );

      if (!profileResponse.ok) {
        console.warn(
          "[MVD] Mise à jour langue/pays refusée :",
          profileResponse.status,
          await profileResponse.text()
        );
      }
    } catch (error) {
      console.warn(
        "[MVD] Mise à jour du profil Klaviyo :",
        error
      );
    }
  }

  // PANIER SHOPIFY

  async function getCart() {
    const response = await fetch(
      "/cart.js",
      {
        credentials: "same-origin",
        cache: "no-store"
      }
    );

    if (!response.ok) {
      throw new Error(
        "Lecture du panier impossible"
      );
    }

    return response.json();
  }

  // ACTUALISER LE PANIER

  function refreshCart() {
    document.dispatchEvent(
      new CustomEvent("mvd:cart-refresh")
    );
  }

  // APPLIQUER UN CODE PROMOTIONNEL SHOPIFY

  async function applyDiscount(code) {
    const response = await fetch(
      "/discount/" +
      encodeURIComponent(code) +
      "?redirect=/cart",

      {
        credentials: "same-origin",
        cache: "no-store",
        redirect: "follow"
      }
    );

    if (!response.ok) {
      throw new Error(
        "Code promotionnel non préparé : " +
        code
      );
    }
  }

  // DÉTECTER LES DIAMOND PAINTINGS

  async function getCollectionIds() {
    if (!collectionPromise) {
      collectionPromise = fetch(
        collectionPath() +
        "/products.json?limit=250",

        {
          credentials: "same-origin",
          cache: "no-store"
        }
      )

      .then(response => {
        if (!response.ok) {
          throw new Error(
            "Collection inaccessible"
          );
        }

        return response.json();
      })

      .then(data =>
        new Set(
          (data.products || []).map(
            product => Number(product.id)
          )
        )
      )

      .catch(error => {
        collectionPromise = null;

        console.warn(
          "[MVD] Collection",
          error
        );

        return new Set();
      });
    }

    return collectionPromise;
  }

  // RECONNAÎTRE UN CADEAU DE LA ROUE

  function isWheelGift(item) {
    const props = item.properties || {};

    return (
      props._mvd_wheel_gift === "yes" ||

      props["🎁 Votre cadeau de bienvenue"] ===
        "Roue de la chance"
    );
  }

  // RECONNAÎTRE UN DIAMOND PAINTING PAR SON NOM

  function matchesPaintingText(item) {
    const text = [
      item.product_title,
      item.title,
      item.product_type,
      item.handle
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return (
      /diamond[\s-]*painting/.test(text) ||
      /diamond[\s-]*art/.test(text) ||
      /peinture[\s-]*(en[\s-]*)?diamant/.test(text)
    );
  }

  // VÉRIFIER QU'UN DIAMOND PAINTING EST AU PANIER

  async function hasDiamondPainting(cart) {
    const ids = await getCollectionIds();

    return (cart.items || []).some(item => {
      if (isWheelGift(item)) {
        return false;
      }

      return (
        ids.has(Number(item.product_id)) ||
        matchesPaintingText(item)
      );
    });
  }

  // RÉCUPÉRER LA VARIANTE DU CADEAU

  // Pour les États-Unis, le handle provient
  // des liens de produits américains.

  async function getGiftVariant(handle) {
    if (variantCache[handle]) {
      return variantCache[handle];
    }

    const response = await fetch(
      (
        isUS()
          ? "/en/products/"
          : "/products/"
      ) +
      encodeURIComponent(handle) +
      ".js",

      {
        credentials: "same-origin",
        cache: "no-store"
      }
    );

    if (!response.ok) {
      throw new Error(
        "Cadeau introuvable : " +
        handle
      );
    }

    const product = await response.json();

    const variant = (
      product.variants || []
    ).find(item => item.available);

    if (!variant) {
      throw new Error(
        "Cadeau indisponible"
      );
    }

    variantCache[handle] =
      Number(variant.id);

    return variantCache[handle];
  }

  // IDENTIFIER LES LIGNES CADEAU DU PANIER

  function getGiftLines(cart, variantId) {
    return (cart.items || []).filter(
      item =>
        isWheelGift(item) &&
        Number(item.variant_id) ===
          Number(variantId)
    );
  }

  // AJOUTER LE CADEAU AU PANIER

  async function addGift(variantId) {
    const response = await fetch(
      "/cart/add.js",

      {
        method: "POST",
        credentials: "same-origin",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },

        body: JSON.stringify({
          id: variantId,
          quantity: 1,

          properties: {
            [CONFIG.giftProperty]:
              CONFIG.giftValue
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        "Ajout du cadeau refusé"
      );
    }
  }

  // RETIRER LE CADEAU SI LES CONDITIONS
  // NE SONT PAS REMPLIES

  async function removeGiftLines(
    cart,
    variantId
  ) {
    const lines = getGiftLines(
      cart,
      variantId
    );

    for (const item of lines) {
      const response = await fetch(
        "/cart/change.js",

        {
          method: "POST",
          credentials: "same-origin",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          "Retrait du cadeau impossible"
        );
      }
    }

    return lines.length > 0;
  }

  // VÉRIFIER QUE LE CADEAU EST GRATUIT

  function giftIsFree(cart, variantId) {
    const lines = getGiftLines(cart, variantId);

    return (
      lines.length > 0 &&
      lines.every(
        item =>
          Number(item.final_line_price) === 0
      )
    );
  }

  // RÉCUPÉRER LES RÉDUCTIONS SHOPIFY

  function getDiscounts(cart) {
    const applications = [
      ...(cart.cart_level_discount_applications || []),
      ...(cart.discount_applications || [])
    ];

    for (const item of cart.items || []) {
      const allocations = [
        ...(item.line_level_discount_allocations || []),
        ...(item.discount_allocations || [])
      ];

      for (const allocation of allocations) {
        if (allocation.discount_application) {
          applications.push(
            allocation.discount_application
          );
        }
      }
    }

    return applications;
  }

  // VÉRIFIER SI LE CODE PROMO EST APPLIQUÉ

  function codeIsApplied(cart, code) {
    const wanted = String(code).toUpperCase();

    return getDiscounts(cart).some(
      application =>
        String(
          application.code ||
          application.title ||
          ""
        ).toUpperCase() === wanted
    );
  }

  // VÉRIFIER SI UNE RÉDUCTION EXISTE

  function hasActualReduction(cart) {
    return (
      Number(cart.total_discount || 0) > 0 ||
      (cart.items || []).some(
        item =>
          Number(item.original_line_price) >
          Number(item.final_line_price)
      )
    );
  }

  // CONFIRMER LE GAIN

  function rewardIsConfirmed(
    cart,
    reward,
    variantId
  ) {
    if (reward.type === "lose") {
      return false;
    }

    if (reward.type === "gift") {
      return giftIsFree(cart, variantId);
    }

    if (reward.type === "shipping") {
      return false;
    }

    return (
      codeIsApplied(cart, reward.code) &&
      hasActualReduction(cart)
    );
  }

  // TROUVER LA BARRE DE LIVRAISON DU PANIER

  function findShippingWrapper() {
    const drawer = document.getElementById(
      "mvd-cart-drawer"
    );

    if (!drawer) return null;

    const text = drawer.querySelector(
      "#mvd-shipping-text"
    );

    if (!text) return null;

    const progress =
      drawer.querySelector(
        "#mvd-shipping-progress"
      ) ||
      drawer.querySelector(
        ".mvd-shipping-progress"
      );

    if (progress) {
      let parent = text.parentElement;

      while (parent && parent !== drawer) {
        if (
          parent.contains(progress) &&
          !parent.contains(
            drawer.querySelector(
              "#mvd-cart-items"
            )
          )
        ) {
          return parent;
        }

        parent = parent.parentElement;
      }
    }

    return text.parentElement;
  }

  // MASQUER LA BARRE SI LIVRAISON OFFERTE

  function updateShippingVisibility() {
    const reward = getReward();

    const hide = Boolean(
      reward &&
      reward.type === "shipping" &&
      isAllowedAudience()
    );

    const wrapper = findShippingWrapper();

    if (!wrapper) return;

    if (hide) {
      wrapper.style.setProperty(
        "display",
        "none",
        "important"
      );
    } else {
      wrapper.style.removeProperty(
        "display"
      );
    }
  }

  // NOMS DES CADEAUX EN ANGLAIS

  function prizeLabel(prize) {
    if (!isUS()) {
      return prize.name;
    }

    const labels = {
      BIENVENUE10:
        "10% OFF",

      PLATBIENV:
        "Free Sorting Tray",

      "MVD-LOSE-1":
        "OH NO! ",

      "ROUE-BOITE-56":
        "Free 56-Slot Storage Box",

      "MVD-LOSE-2":
        "OH NO! ",

      ROUESTYLO:
        "Free Multi-Placer Pen"
    };

    return (
      labels[prize.code] ||
      prize.name
    );
  }

  // TITRES DU BANDEAU CADEAU

  function getTitle(reward, status) {

    // VERSION AMÉRICAINE

    if (isUS()) {
      if (reward.type === "lose") {
        return "😢 OH NO!";
      }

      if (reward.type === "shipping") {
        return status === "eligible"
          ? "🚚 Your free shipping is unlocked!"
          : "🚚 Your free shipping is waiting!";
      }

      if (reward.type === "fixed") {
        return status === "unlocked"
          ? "🎉 Your $5 discount is applied!"
          : "🎉 You won $5 OFF!";
      }

      if (reward.type === "percent") {
        return status === "unlocked"
          ? "🎉 Your 10% discount is applied!"
          : "🎉 You won 10% OFF!";
      }

      return status === "unlocked"
        ? "🎁 Your free gift is unlocked!"
        : "🎁 Your free gift is waiting!";
    }

    // VERSION FRANÇAISE

    if (reward.type === "lose") {
      return "😢 Dommage !";
    }

    if (reward.type === "shipping") {
      return status === "eligible"
        ? "🚚 Votre livraison offerte est débloquée !"
        : "🚚 Votre livraison offerte est en attente !";
    }

    if (reward.type === "fixed") {
      return status === "unlocked"
        ? "🎉 Vos 5 € sont appliqués !"
        : "🎉 Vous avez gagné 5 € !";
    }

    if (reward.type === "percent") {
      return status === "unlocked"
        ? "🎉 Vos 10 % sont appliqués !"
        : "🎉 Vous avez gagné 10 % !";
    }

    return status === "unlocked"
      ? "🎁 Votre cadeau est débloqué !"
      : "🎁 Votre cadeau est en attente !";
  }

  // DESCRIPTIONS DU BANDEAU CADEAU

  function getDescription(reward, status) {

    // VERSION AMÉRICAINE

    if (isUS()) {

      if (reward.type === "lose") {
        return (
          "No prize this time. Thank you for participating!"
        );
      }

      if (reward.type === "shipping") {
        if (status === "eligible") {
          return (
            "Your Diamond Painting Kit is in your cart. " +
            "Free shipping will be applied at checkout, " +
            "subject to offer conditions."
          );
        }

        return (
          "Add a Diamond Painting Kit to your cart " +
          "to unlock free shipping."
        );
      }

      if (status === "unlocked") {

        if (reward.type === "fixed") {
          return (
            "Your $5 discount has been applied " +
            "to your cart."
          );
        }

        if (reward.type === "percent") {
          return (
            "Your 10% discount has been applied " +
            "to your cart."
          );
        }

        return (
          prizeLabel(reward) +
          " has been added to your cart for free."
        );
      }

      if (status === "checking") {
        return (
          "Your Diamond Painting Kit is in your cart. " +
          "Checking your reward…"
        );
      }

      if (status === "error") {
        return reward.type === "gift"
          ? (
              "Your gift is pending: we couldn't confirm " +
              "that it's free, so we removed the paid item."
            )
          : (
              "Your discount is pending: " +
              "we couldn't confirm it was applied."
            );
      }

      if (reward.type === "fixed") {
        return (
          "Your $5 discount is waiting! " +
          "Add a Diamond Painting Kit to unlock it."
        );
      }

      if (reward.type === "percent") {
        return (
          "Your 10% discount is waiting! " +
          "Add a Diamond Painting Kit to unlock it."
        );
      }

      return (
        "You won " +
        prizeLabel(reward) +
        "! Add a Diamond Painting Kit to your cart " +
        "to receive your gift for free."
      );
    }

    // VERSION FRANÇAISE

    if (reward.type === "lose") {
      return (
        "Pas de cadeau cette fois-ci. " +
        "Merci d'avoir participé !"
      );
    }

    if (reward.type === "shipping") {

      if (status === "eligible") {
        return (
          "Votre Diamond Painting est ajouté. " +
          "Votre livraison offerte sera appliquée " +
          "lors de la commande, selon les conditions de l'offre."
        );
      }

      return (
        "Ajoutez un Diamond Painting à votre panier " +
        "pour débloquer votre livraison offerte."
      );
    }

    if (status === "unlocked") {

      if (reward.type === "fixed") {
        return (
          "Votre réduction de 5 € est appliquée " +
          "à votre panier."
        );
      }

      if (reward.type === "percent") {
        return (
          "Votre réduction de 10 % est appliquée " +
          "à votre panier."
        );
      }

      return (
        reward.name +
        " : votre cadeau a été ajouté gratuitement " +
        "à votre panier."
      );
    }

    if (status === "checking") {
      return (
        "Votre Diamond Painting est ajouté. " +
        "Nous vérifions votre avantage…"
      );
    }

    if (status === "error") {
      return reward.type === "gift"
        ? (
            "Votre cadeau est en attente : " +
            "sa gratuité n'a pas encore été confirmée. " +
            "Il n'a pas été conservé comme produit payant."
          )
        : (
            "Votre réduction est en attente : " +
            "son application n'a pas encore été confirmée."
          );
    }

    if (reward.type === "fixed") {
      return (
        "Votre réduction de 5 € est en attente ! " +
        "Ajoutez un Diamond Painting pour en profiter."
      );
    }

    if (reward.type === "percent") {
      return (
        "Votre réduction de 10 % est en attente ! " +
        "Ajoutez un Diamond Painting pour en profiter."
      );
    }

    return (
      "Vous avez gagné : " +
      reward.name +
      ". Ajoutez un Diamond Painting à votre panier " +
      "pour recevoir votre cadeau gratuitement."
    );
  }

  // AFFICHER LE BANDEAU DANS LE PANIER

  function showNotice(reward, status) {
    const existingNotice = document.getElementById(
      "mvd-wheel-reward-notice"
    );

    if (
      !reward ||
      reward.type === "lose" ||
      !hasPlayed() ||
      !isAllowedAudience()
    ) {
      existingNotice?.remove();
      return;
    }

    const drawer = document.getElementById(
      "mvd-cart-drawer"
    );

    if (
      !drawer ||
      !reward ||
      !isAllowedAudience()
    ) {
      return;
    }

    let notice = drawer.querySelector(
      "#mvd-wheel-reward-notice"
    );

    if (!notice) {
      notice = document.createElement("div");

      notice.id =
        "mvd-wheel-reward-notice";

      notice.style.cssText = [
        "padding:15px 18px",
        "background:#edf5ef",
        "color:#315c45",
        "font-size:13px",
        "line-height:1.5",
        "border-bottom:1px solid #d4e6d9"
      ].join(";");

      const header = drawer.querySelector(
        ".mvd-cart-head"
      );

      if (header) {
        header.insertAdjacentElement(
          "afterend",
          notice
        );
      } else {
        drawer.prepend(notice);
      }
    }

    notice.replaceChildren();

    // TITRE

    const title = document.createElement(
      "div"
    );

    title.style.cssText = [
      "font-weight:800",
      "font-size:14px",
      "margin-bottom:5px"
    ].join(";");

    title.textContent = getTitle(
      reward,
      status
    );

    // DESCRIPTION

    const description =
      document.createElement("div");

    description.textContent =
      getDescription(reward, status);

    notice.append(
      title,
      description
    );

    // BOUTON SI CADEAU EN ATTENTE

    if (status === "pending") {
      const link = document.createElement(
        "a"
      );

      link.href = collectionPath();

      link.textContent = localized(
        "Découvrir nos Diamond Paintings →",
        "Shop Diamond Painting Kits →"
      );

      link.style.cssText = [
        "display:block",
        "margin-top:11px",
        "padding:10px 12px",
        "border-radius:5px",
        "background:#486D59",
        "color:#FFFFFF",
        "text-align:center",
        "font-weight:700",
        "text-decoration:none"
      ].join(";");

      notice.appendChild(link);
    }

    updateShippingVisibility();
  }

  // SYNCHRONISATION DES RÉCOMPENSES

  async function syncReward() {
    if (!isAllowedAudience()) {
      return;
    }

    const reward = getReward();

    if (!reward || reward.type === "lose") {
      updateShippingVisibility();
      return;
    }

    // ÉVITER PLUSIEURS SYNCHRONISATIONS
    // SIMULTANÉES

    if (syncBusy) {
      syncAgain = true;
      return;
    }

    syncBusy = true;

    try {
      // NOUVELLE RÉCOMPENSE

      if (lastRewardId !== reward.rewardId) {
        lastRewardId = reward.rewardId;
        lastStatus = "pending";
        failedSignature = null;
      }

      // LECTURE DU PANIER

      let cart = await getCart();

      const eligible =
        await hasDiamondPainting(cart);

      // SIGNATURE DU PANIER POUR ÉVITER
      // LES TENTATIVES EN BOUCLE

      const signature = (cart.items || [])
        .filter(item => !isWheelGift(item))
        .map(
          item =>
            item.key + ":" + item.quantity
        )
        .sort()
        .join("|");

      // IDENTIFIANT DE LA VARIANTE CADEAU

      let variantId = null;

      if (reward.type === "gift") {
        variantId = await getGiftVariant(
          reward.handle
        );
      }

      // AUCUN DIAMOND PAINTING AU PANIER

      if (!eligible) {
        if (reward.type === "gift") {
          const removed =
            await removeGiftLines(
              cart,
              variantId
            );

          if (removed) {
            refreshCart();
          }
        }

        lastStatus = "pending";
        failedSignature = null;

        showNotice(reward, "pending");

        return;
      }

      // LIVRAISON OFFERTE
      // COMPATIBILITÉ AVEC LES ANCIENS GAINS V18

      if (reward.type === "shipping") {
        lastStatus = "eligible";

        showNotice(
          reward,
          "eligible"
        );

        return;
      }

      // RÉCOMPENSE DÉJÀ CONFIRMÉE

      if (
        rewardIsConfirmed(
          cart,
          reward,
          variantId
        )
      ) {
        lastStatus = "unlocked";
        failedSignature = null;

        showNotice(
          reward,
          "unlocked"
        );

        return;
      }

      // ÉVITER DE RÉESSAYER SANS MODIFICATION
      // DU PANIER APRÈS UNE ERREUR

      if (
        lastStatus === "error" &&
        failedSignature === signature
      ) {
        showNotice(
          reward,
          "error"
        );

        return;
      }

      // AVANTAGE EN COURS DE VÉRIFICATION

      showNotice(
        reward,
        "checking"
      );

      // AJOUTER LE CADEAU PHYSIQUE

      if (reward.type === "gift") {
        const existing = getGiftLines(
          cart,
          variantId
        );

        if (!existing.length) {
          await addGift(
            variantId
          );
        }
      }

      // ACTIVER LE CODE PROMOTIONNEL

      await applyDiscount(
        reward.code
      );

      // LAISSER SHOPIFY METTRE À JOUR
      // LES RÉDUCTIONS

      await sleep(400);

      // RELIRE LE PANIER

      cart = await getCart();

      // VÉRIFIER QUE LA RÉCOMPENSE
      // EST BIEN APPLIQUÉE

      if (
        rewardIsConfirmed(
          cart,
          reward,
          variantId
        )
      ) {
        lastStatus = "unlocked";
        failedSignature = null;

      } else {

        // SI LE CADEAU N'EST PAS GRATUIT,
        // NE PAS LE LAISSER PAYANT AU PANIER

        if (reward.type === "gift") {
          await removeGiftLines(
            cart,
            variantId
          );
        }

        lastStatus = "error";
        failedSignature = signature;
      }

      // ACTUALISER L'AFFICHAGE

      showNotice(
        reward,
        lastStatus
      );

      refreshCart();

    } catch (error) {

      console.error(
        "[MVD] Erreur récompense",
        error
      );

      // SÉCURITÉ POUR LES CADEAUX PHYSIQUES

      if (reward.type === "gift") {
        try {
          const cart = await getCart();

          const variantId =
            await getGiftVariant(
              reward.handle
            );

          if (
            !giftIsFree(
              cart,
              variantId
            )
          ) {
            await removeGiftLines(
              cart,
              variantId
            );

            refreshCart();
          }

        } catch (cleanupError) {
          console.error(
            "[MVD] Retrait cadeau",
            cleanupError
          );
        }
      }

      lastStatus = "error";

      showNotice(
        reward,
        "error"
      );

    } finally {

      syncBusy = false;

      // RELANCER SI LE PANIER A CHANGÉ
      // PENDANT LA SYNCHRONISATION

      if (syncAgain) {
        syncAgain = false;
        scheduleSync();
      }
    }
  }

  // PLANIFIER UNE SYNCHRONISATION

  function scheduleSync() {
    clearTimeout(
      syncTimer
    );

    syncTimer = setTimeout(
      syncReward,
      450
    );
  }

  // ACTIVER LA RÉCOMPENSE APRÈS LE TIRAGE

  async function activatePrize(prize) {
    if (prize.type === "lose") {
      return;
    }

    const reward = getReward();

    if (
      !reward ||
      reward.code !== prize.code
    ) {
      return;
    }

    // POUR LES RÉDUCTIONS ET LA LIVRAISON,
    // PRÉPARER LE CODE SHOPIFY

    if (reward.type !== "gift") {
      try {
        await applyDiscount(
          reward.code
        );

      } catch (error) {
        console.warn(
          "[MVD] Code promotionnel",
          error
        );
      }
    }

    // VÉRIFIER L'APPLICATION DU GAIN
    // DANS LE PANIER

    await syncReward();
  }

  // ÉVÉNEMENTS DU PANIER

  [
    "mvd:cart-refresh",
    "cart:refresh",
    "cart:updated"
  ].forEach(name => {
    document.addEventListener(
      name,
      scheduleSync
    );
  });

  // SURVEILLANCE DES REQUÊTES PANIER

  function installCartWatcher() {
    if (window.__mvdWheelFinalWatcher) {
      return;
    }

    window.__mvdWheelFinalWatcher = true;

    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      const promise = originalFetch.apply(
        this,
        args
      );

      let url = "";

      try {
        const request = args[0];

        url = String(
          typeof request === "string"
            ? request
            : request.url || ""
        );
      } catch (error) {}

      if (
        /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)
      ) {
        promise
          .then(response => {
            if (response.ok) {
              setTimeout(
                scheduleSync,
                500
              );
            }
          })
          .catch(() => {});
      }

      return promise;
    };
  }

  installCartWatcher();

  // OBSERVER LES ACTUALISATIONS DU PANIER

  function installDrawerObserver() {
    const drawer = document.getElementById(
      "mvd-cart-drawer"
    );

    if (!drawer || drawerObserver) {
      return;
    }

    drawerObserver = new MutationObserver(() => {
      const reward = getReward();

      if (
        !reward ||
        reward.type === "lose" ||
        !isAllowedAudience()
      ) {
        return;
      }

      if (
        !drawer.querySelector(
          "#mvd-wheel-reward-notice"
        )
      ) {
        showNotice(
          reward,
          lastStatus
        );
      }

      updateShippingVisibility();
    });

    drawerObserver.observe(drawer, {
      childList: true,
      subtree: false
    });
  }

  // INITIALISATION DE LA ROUE

  function init(root) {
    if (
      !root ||
      root.dataset.mvdInitialized === "1"
    ) {
      return;
    }

    const $ = selector =>
      root.querySelector(selector);

    const popup = $(".mw-popup");
    const overlay = $(".mw-overlay");
    const tab = $(".mw-tab");
    const wheel = $(".mw-wheel");
    const form = $(".mw-form");
    const submit = $(".mw-submit");
    const status = $(".mw-status");
    const email = $(".mw-email");
    const closeButton = $(".mw-close");
    const decline = $(".mw-decline");

    // Masquer la croix de la pop-up
    if (closeButton) {
      closeButton.style.display = "none";
    }

    const result = $(".mw-result");
    const prizeText = $(".mw-prize");
    const legal = $(".mw-legal");
    const shopButton = $(".mw-shop");
    const demo = $(".mw-demo");

    if (
      !popup ||
      !overlay ||
      !tab ||
      !wheel ||
      !form ||
      !submit ||
      !status ||
      !email ||
      !closeButton ||
      !decline ||
      !result ||
      !prizeText
    ) {
      return;
    }

    root.dataset.mvdInitialized = "1";
    currentRoot = root;

    if (
      root.parentElement !== document.body
    ) {
      document.body.appendChild(root);
    }

    // Agrandir le bouton « Non merci »
    if (decline) {
      decline.style.fontSize = "15px";
      decline.style.fontWeight = "550";
      decline.style.padding = "13px 19px";
      decline.style.minHeight = "45px";
    }

    // EXCLUSION DES VISITEURS NON ÉLIGIBLES

    if (!isAllowedAudience()) {
      popup.hidden = true;
      overlay.hidden = true;
      tab.hidden = true;
      root.hidden = true;
      return;
    }

    // NE PAS RÉAFFICHER APRÈS PARTICIPATION

    if (hasPlayed()) {
      popup.hidden = true;
      overlay.hidden = true;
      tab.hidden = true;
      root.hidden = true;
      return;
    }

    // TRADUCTION AUTOMATIQUE US

    if (isUS()) {
      const setText = (
        selector,
        value
      ) => {
        const node =
          root.querySelector(selector);

        if (node) {
          node.textContent = value;
        }
      };

      setText(
        ".mw-tab-open",
        "🎁 Your gift is waiting"
      );

      setText(
        ".mw-content h2",
        "SPIN TO WIN A GIFT! 🎁"
      );

      const intro = root.querySelector(
        ".mw-intro"
      );

      if (intro) {
        intro.textContent =
          "Enter your email to spin the wheel.";
      }

      setText(
        ".mw-submit",
        "SPIN THE WHEEL"
      );

      setText(
        ".mw-decline",
        "NO, THANKS"
      );

      setText(
        ".mw-result h3",
        "🎉 Congratulations!"
      );

      email.placeholder =
        "Your email address";

      // MENTIONS D'INSCRIPTION EN ANGLAIS

      if (legal) {
        legal.textContent =
          "By clicking Spin the Wheel, " +
          "you agree to receive offers and updates " +
          "by email. You can unsubscribe at any time. ";

        const privacy =
          document.createElement("a");

        privacy.href =
          "/en/policies/privacy-policy";

        privacy.textContent =
          "Privacy Policy";

        legal.appendChild(privacy);
      }
    }

    // LES SIX CASES VISUELLES

    const labels = isUS()
      ? [
          "10% OFF",
          "SORTING TRAY",
          "OH NO!😭",
          "DIAMOND STORAGE BOX",
          "OH NO!😭",
          "MULTI-PLACER PEN"
        ]
      : [
          "10 % DE RÉDUCTION",
          "PLATEAU DE TRI",
          "😢 DOMMAGE !",
          "BOÎTE DE RANGEMENT",
          "😢 DOMMAGE !",
          "STYLO MULTI-EMBOUTS"
        ];

    wheel.querySelectorAll(
      ".mw-reward span"
    ).forEach((node, index) => {
      if (labels[index]) {
        node.textContent = labels[index];
      }
    });

    // RÉCOMPENSES VISUELLES DE LA ROUE

    const rewards = Array.from(
      wheel.querySelectorAll(
        ".mw-reward"
      )
    );

    let rotation = 0;
    let spinning = false;
    let played = false;
    let idleId = null;
    let lastFrame = null;

    // ROTATION DE LA ROUE

    function setRotation(angle) {
      rotation = angle;

      wheel.style.transform =
        `rotate(${angle}deg)`;

      rewards.forEach(
        (element, index) => {
          const prize = PRIZES[index];

          if (!prize) {
            return;
          }

          element.style.transform =
            "translate(-50%, -50%) " +
            `rotate(${-prize.angle - angle}deg)`;
        }
      );
    }

    setRotation(0);

    // ROTATION LENTE AVANT PARTICIPATION

    function idleFrame(timestamp) {
      if (
        spinning ||
        played ||
        popup.hidden
      ) {
        idleId = null;
        lastFrame = null;
        return;
      }

      if (lastFrame === null) {
        lastFrame = timestamp;
      }

      const elapsed = Math.min(
        timestamp - lastFrame,
        100
      );

      lastFrame = timestamp;

      setRotation(
        rotation +
        elapsed * CONFIG.idleSpeed
      );

      idleId =
        requestAnimationFrame(
          idleFrame
        );
    }

    function startIdle() {
      if (
        spinning ||
        played ||
        popup.hidden ||
        idleId !== null
      ) {
        return;
      }

      lastFrame = null;

      idleId =
        requestAnimationFrame(
          idleFrame
        );
    }

    function stopIdle() {
      if (idleId !== null) {
        cancelAnimationFrame(
          idleId
        );

        idleId = null;
      }

      lastFrame = null;
    }

    // BOUTON CADEAU FLOTTANT

    function showTab() {
      const visible =
        isAllowedAudience() &&
        !hasPlayed() &&
        !played &&
        !isDismissed();

      root.hidden = !visible;
      tab.hidden = !visible;

      return visible;
    }

    // OUVERTURE DU POP-UP

    function open(manual = false) {
      if (
        !isAllowedAudience() ||
        hasPlayed() ||
        played ||
        spinning ||
        isDismissed() ||
        (
          !manual &&
          isClosedRecently()
        )
      ) {
        return;
      }

      root.hidden = false;
      popup.hidden = false;
      overlay.hidden = false;
      tab.hidden = true;

      startIdle();
    }

    // FERMETURE SANS PARTICIPATION

    function close() {
      if (spinning) {
        return;
      }

      stopIdle();

      popup.hidden = true;
      overlay.hidden = true;

      if (
        !played &&
        !hasPlayed()
      ) {
        markClosed();
        showTab();
      } else {
        tab.hidden = true;
      }
    }

    // CLIQUER SUR LE BOUTON CADEAU

    const tabOpen =
      tab.querySelector(
        ".mw-tab-open"
      );

    if (tabOpen) {
      tabOpen.addEventListener(
        "click",
        () => {
          open(true);
        }
      );
    } else {
      tab.addEventListener(
        "click",
        () => {
          open(true);
        }
      );
    }

    // PETITE CROIX : MASQUAGE 30 JOURS

    const dismissButton =
      tab.querySelector(
        ".mw-tab-dismiss"
      );

    if (dismissButton) {
      dismissButton.addEventListener(
        "click",
        event => {
          event.preventDefault();
          event.stopPropagation();

          dismissForMonth();
          stopIdle();

          popup.hidden = true;
          overlay.hidden = true;
          tab.hidden = true;
          root.hidden = true;
        }
      );
    }

    // AUTRES FERMETURES

    closeButton.addEventListener(
      "click",
      close
    );

    decline.addEventListener(
      "click",
      close
    );

    overlay.addEventListener(
      "click",
      close
    );

    document.addEventListener(
      "keydown",
      event => {
        if (
          event.key === "Escape" &&
          !popup.hidden
        ) {
          close();
        }
      }
    );

    // CHOIX DU GAIN SELON LES PROBABILITÉS

    function choosePrize() {
      const total = PRIZES.reduce(
        (sum, prize) =>
          sum + prize.weight,
        0
      );

      let random =
        Math.random() * total;

      for (const prize of PRIZES) {
        random -= prize.weight;

        if (random < 0) {
          return prize;
        }
      }

      return PRIZES[
        PRIZES.length - 1
      ];
    }

    // ANIMATION DU TIRAGE

    function spinTo(prize) {
      stopIdle();

      return new Promise(
        resolve => {
          const start = rotation;

          const currentAngle =
            normalize(start);

          const targetAngle =
            normalize(
              360 - prize.angle
            );

          const delta =
            normalize(
              targetAngle -
              currentAngle
            );

          const end =
            start + 2160 + delta;

          let startTime = null;

          function frame(timestamp) {
            if (
              startTime === null
            ) {
              startTime = timestamp;
            }

            const progress =
              Math.min(
                (
                  timestamp -
                  startTime
                ) /
                  CONFIG.spinDuration,
                1
              );

            const eased =
              1 -
                Math.pow(
                  1 - progress,
                  4
                );

            setRotation(
              start +
              (
                end - start
              ) * eased
            );

            if (progress < 1) {
              requestAnimationFrame(
                frame
              );
            } else {
              setRotation(end);
              resolve();
            }
          }

          requestAnimationFrame(
            frame
          );
        }
      );
    }

    // ANIMATION DE RÉVÉLATION DU CADEAU

    async function revealPrize(prize) {
      const wheelWindow = $(".mw-wheel-window");
      if (!wheelWindow) return;

      // Supprimer une éventuelle ancienne animation
      wheelWindow.querySelector(".mw-reveal")?.remove();

      const reveal = document.createElement("div");
      reveal.className = "mw-reveal";

      const gift = document.createElement("div");
      gift.className = "mw-reveal-gift";
      gift.textContent = "🎁";

      const image = document.createElement("img");
      image.className = "mw-reveal-product";
      image.alt = prizeLabel(prize);

      const imageSelector = {
        PLATBIENV: ".mw-plateau-img",
        "ROUE-BOITE-56": ".mw-boite-img",
        ROUESTYLO: ".mw-stylo-img"
      }[prize.code];

      const originalImage = imageSelector
        ? wheel.querySelector(imageSelector)
        : null;

      if (originalImage) {
        image.src = originalImage.src;
      }

      const discount = document.createElement("div");
      discount.className = "mw-reveal-discount";
      discount.textContent = isUS() ? "10% OFF" : "-10 %";

      reveal.append(gift, image, discount);
const textPanel = $(".mw-text-panel");

if (textPanel) {
  textPanel.replaceChildren(reveal);
  textPanel.classList.add("mw-gift-panel");
} else {
  wheelWindow.appendChild(reveal);
}
      // Masquer la roue après son arrêt
      wheelWindow.classList.add("mw-revealing");

      const reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      if (reduceMotion) {
        gift.hidden = true;
      } else {
        await sleep(900);
        gift.classList.add("mw-gift-open");
        await sleep(650);
        gift.hidden = true;
      }

      if (prize.type === "lose") {
        reveal.classList.add("mw-reveal-lost");
        reveal.textContent = "😢";
        return;
      }

      if (prize.type === "percent") {
        discount.classList.add("mw-visible");
      } else if (originalImage) {
        image.classList.add("mw-visible");
      } else {
        discount.textContent = "🎁";
        discount.classList.add("mw-visible");
      }

      // Confettis pour les gagnants uniquement
      if (!reduceMotion) {
        const colors = [
          "#486D59", "#D8B76A",
          "#EF9486", "#A5C6AD"
        ];

        for (let i = 0; i < 36; i++) {
          const confetti = document.createElement("span");
          confetti.className = "mw-reveal-confetti";
          confetti.style.left = Math.random() * 100 + "%";
          confetti.style.background = colors[i % colors.length];
          confetti.style.setProperty(
            "--drift",
            (Math.random() * 140 - 70) + "px"
          );
          confetti.style.animationDelay =
            Math.random() * 0.35 + "s";

          reveal.appendChild(confetti);
        }
      }
    }

    // INSCRIPTION ET PARTICIPATION

    form.addEventListener(
      "submit",
      async event => {
        event.preventDefault();

        if (
          spinning ||
          played ||
          hasPlayed() ||
          !isAllowedAudience() ||
          isDismissed()
        ) {
          return;
        }

        if (
          !email.checkValidity()
        ) {
          email.reportValidity();
          return;
        }

        spinning = true;
        submit.disabled = true;

        status.textContent =
          localized(
            "Inscription en cours…",
            "Signing you up…"
          );

        try {

          // INSCRIPTION KLAVIYO

          await subscribeKlaviyo(
            email.value.trim()
          );

          status.textContent =
            localized(
              "La roue tourne…",
              "Spinning the wheel…"
            );

          // TIRAGE

          const prize =
            choosePrize();

          await spinTo(prize);

          played = true;

          // ENREGISTREMENT DE LA PARTICIPATION

          const reward =
            saveReward(prize);

          // MASQUER LE BOUTON FLOTTANT

          tab.hidden = true;

          // AFFICHER LE RÉSULTAT

          form.hidden = true;
          decline.hidden = true;

          if (legal) {
            legal.hidden = true;
          }

          status.textContent = "";

          
          prizeText.textContent =
            prizeLabel(prize);

          // Animation de révélation du cadeau
          await revealPrize(prize);

/* MVD — VALEUR DU CADEAU FR / US */

const valueBox = root.querySelector(".mw-prize-value");

if (valueBox) {
  const label = prizeLabel(prize).toLowerCase();
  const us = isUS();

  let value = "";

  if (
    label.includes("boîte") ||
    label.includes("box") ||
    label.includes("storage")
  ) {
    value = us ? "$22.90" : "19,90 €";

  } else if (
    label.includes("plateau") ||
    label.includes("tray")
  ) {
    value = us ? "$19.90" : "17,30 €";

  } else if (
    label.includes("stylo") ||
    label.includes("pen")
  ) {
    value = us ? "$29.90" : "24,90 €";
  }

  if (value) {
    valueBox.replaceChildren();

    const oldPrice = document.createElement("span");
    oldPrice.className = "mw-old-price";
    oldPrice.textContent = value;

    const freeLabel = document.createElement("span");
    freeLabel.className = "mw-free-label";
    freeLabel.textContent = us ? "FREE" : "OFFERT";

    valueBox.append(oldPrice, freeLabel);
    valueBox.hidden = false;
  } else {
    valueBox.hidden = true;
  }
}

          result.hidden = false;

          // MESSAGE GAGNANT OU PERDANT

          const resultTitle =
            result.querySelector("h3");

          if (prize.type === "lose") {
            if (resultTitle) {
              resultTitle.textContent =
                localized(
                  "😢 Dommage !",
                  "😢 OH NO!"
                );
            }

            if (demo) {
              demo.textContent =
                localized(
                  "Pas de cadeau cette fois-ci. Merci d'avoir participé !",
                  "No prize this time. Thank you for participating!"
                );
            }
          } else {
            if (resultTitle) {
              resultTitle.textContent =
                localized(
                  "🎉 Félicitations !",
                  "🎉 Congratulations!"
                );
            }

            if (demo) {
              demo.textContent =
                localized(
                  "Votre récompense est en attente ! Ajoutez un Diamond Painting pour en profiter.",
                  "Your reward is waiting! Add a Diamond Painting Kit to unlock it."
                );
            }
          }

          // RESTER SUR LA PAGE APRÈS LE TIRAGE

          if (shopButton) {
           
            shopButton.textContent = localized(
              "DÉCOUVRIR NOS DIAMOND PAINTINGS →",
              "DISCOVER OUR DIAMOND PAINTING KITS →"
            );

            shopButton.href = collectionPath();


            shopButton.addEventListener(
              "click",
              async event => {
                event.preventDefault();

                stopIdle();

                popup.hidden = true;
                overlay.hidden = true;
                tab.hidden = true;

                // UNIQUEMENT POUR LES GAGNANTS

                if (
                  prize.type !== "lose" &&
                  reward
                ) {
                  showGiftReminder();

                  try {
                    await activatePrize(prize);
                  } catch (error) {
                    console.error(
                      "[MVD] Activation",
                      error
                    );
                  }
                }
              },
              { once: true }
            );
          }

          // PRÉPARER LE GAIN AUTOMATIQUEMENT
          // AUCUNE ACTION POUR LES PERDANTS

          if (
            prize.type !== "lose" &&
            reward
          ) {
            scheduleSync();
          }

        } catch (error) {
          console.error(
            "[MVD] Erreur roue",
            error
          );

          status.textContent =
            localized(
              "L'inscription n'a pas pu être validée. Veuillez réessayer.",
              "We couldn't confirm your signup. Please try again."
            );

          submit.disabled = false;

        } finally {
          spinning = false;

          if (!played) {
            startIdle();
          }
        }
      }
    );

    // OUVERTURE AUTOMATIQUE APRÈS 12 SECONDES

    if (
      !hasPlayed() &&
      !isDismissed()
    ) {
      if (isClosedRecently()) {

        // POP-UP DÉJÀ FERMÉ :
        // AFFICHER UNIQUEMENT LE BOUTON

        showTab();

      } else {

        setTimeout(
          () => {
            if (
              popup.isConnected &&
              popup.hidden &&
              !hasPlayed() &&
              !played &&
              !isDismissed() &&
              !isClosedRecently()
            ) {
              open();
            }
          },
          CONFIG.openDelay
        );
      }
    }

    console.info(
      "[MVD] Roue V19 FR/US initialisée",
      getAudience()
    );
  }

  // DÉMARRAGE GÉNÉRAL

  function scan() {
    rememberVisit();

    document
      .querySelectorAll(
        CONFIG.selector
      )
      .forEach(init);

    installDrawerObserver();

    updateShippingVisibility();

    if (getReward()) {
      scheduleSync();
    }
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      scan,
      { once: true }
    );
  } else {
    scan();
  }

  // RECHARGEMENT DES SECTIONS SHOPIFY

  document.addEventListener(
    "shopify:section:load",
    scan
  );

  // SUIVI DES RÉCOMPENSES ACTIVES

  setInterval(
    () => {
      if (
        !getReward() ||
        !isAllowedAudience()
      ) {
        return;
      }

      installDrawerObserver();

      updateShippingVisibility();

      scheduleSync();
    },
    4000
  );

})();

/* MVD — Continuer sur cette page */

(() => {
  const root = document.querySelector("#mvd-wheel-v12");
  if (!root) return;

  root.addEventListener("click", (event) => {
    if (!event.target.closest(".mw-stay")) return;

    const closeButton = root.querySelector(".mw-close");

    // Utiliser la fermeture existante de la roue
    // pour conserver son fonctionnement normal.
    if (closeButton) {
      closeButton.click();
    }
  });
})();

